<template>
  <v-app id="inspire" class="vazir-font">
    <v-main>
      <v-container fluid>
        <public-logo></public-logo>
        <v-row justify="center" class="my-4">
          <v-alert border="bottom" colored-border type="warning" elevation="2">
            {{ $vuetify.lang.translator("message403") }}
          </v-alert>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn
              color="primary"
              @click="$router.push({ name: 'Dashboard' })"
              >{{ $vuetify.lang.translator("dashboard") }}</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import PublicLogo from "@/components/PublicLogo";

export default {
  name: "Error403",
  components: {
    PublicLogo
  }
};
</script>
